import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import authService from '../services/auth.service';

const Sucess = () => {

    const dispatch = useDispatch();
  
  useEffect(() => {
     authService.getUser(dispatch);
  }, [dispatch]);

    const studentInformation = useSelector((state) => state.auth.studentData);


    const [paymentStatus,setpaymentStatus] = useState("")
    
  useEffect(() => {
      if (!studentInformation || !Array.isArray(studentInformation.transactions) || studentInformation.transactions.length === 0) {
        setpaymentStatus("Pending");
      } else {
        setpaymentStatus(studentInformation.transactions[studentInformation.transactions.length - 1]);
      }
    }, [studentInformation]);

    
      const navigate = useNavigate();
      const backtodashboard = () => {
        navigate("/student/dashboard", { replace: true });
      };


      const params = new URLSearchParams(window.location.search)
      console.log(params)
  return (
    <div>
      <div className="payment-successful-container">
            <div className="payment-successful-content">
              {/* Header Section */}
              <div className="payment-successful-header">
                <div className="payment-successful-icon-container">
                  <svg
                    className="payment-successful-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h1 className="payment-successful-title">
                  Payment Successful!
                </h1>
                <p className="payment-successful-subtitle">
                  Your payment has been processed successfully.
                </p>
              </div>

              {/* Confirmation Details Card */}
              <div className="payment-successful-card">
                <h2 className="payment-successful-card-title">
                  Transaction Details
                </h2>
                <div className="payment-successful-details">
                  <div className="payment-successful-detail-row">
                    <span className="payment-successful-detail-label">
                      Amount:
                    </span>
                    <span className="payment-successful-detail-value">
                      {`₹${paymentStatus.amount}`}
                    </span>
                  </div>
                  <div className="payment-successful-detail-row">
                    <span className="payment-successful-detail-label">
                      Date:
                    </span>
                    <span className="payment-successful-detail-value">
                      {new Date().toLocaleDateString()}
                    </span>
                  </div>
                  <div className="payment-successful-detail-row">
                    <span className="payment-successful-detail-label">
                      Reference:
                    </span>
                    <span className="payment-successful-detail-value payment-successful-reference">
                      {paymentStatus.txnid  || "0"}
                    </span>
                  </div>
                  <div className="payment-successful-detail-row">
                    <span className="payment-successful-detail-label">
                      Status:
                    </span>
                    <span className="payment-successful-detail-value payment-successful-status">
                      Completed
                    </span>
                  </div>
                </div>
              </div>

              {/* Call to Action */}
              <div className="payment-successful-actions">
                <button
                  onClick={backtodashboard}
                  className="payment-successful-primary-button"
                >
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
    </div>
  )
}

export default Sucess
